import _convertToHtml from "../functions/quill/convertToHtml.js";
import _dict from "../dict/708.js";
import _tsLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tsLib = _tsLib;
const dict = _dict;
const convertToHtml = _convertToHtml;
export default {
  decode: function (input, options) {
    let lines = input.split("\n");
    let events = [];
    lines.forEach((line, i) => {
      if (line.startsWith("CAPTION")) {
        let e = new Event();
        // Get Time
        let h = line.split(",")[3];
        let m = line.split(",")[4];
        let s = line.split(",")[5];
        let f = line.split(",")[6];
        let timecode = tsLib.tcToSec(`${h}:${m}:${s}:${f}`, options.frameRate, options.dropFrame);
        e.start = timecode;
        if (events.length > 0) {
          events[events.length - 1].end = timecode;
        }

        // Get Text
        let dataRegex = /^DATA,\d\d,\d,(.*)/g;
        let data = dataRegex.exec(lines[i + 1]);
        if (data && data.length > 0) {
          data[1].split(",");
          let string = data[1].split(",").map(hex => dict.cmds[hex.slice(-2)]).join('');
          e.text = convertToHtml(string);
        }
        events.push(e);
      }
    });
    if (!events[events.length - 1].end) {
      events[events.length - 1].end = events[events.length - 1].start + 3;
    }
    return events;
  },
  encode: function () {
    throw new Error("This profile [MacCaption Project] is not supported for encoding by Closed Caption Converter.");
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};